var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNewBloombergLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 324.752,
    height: 59.839,
    viewBox: "0 0 324.752 59.839",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "New_Bloomberg_Logo",
    transform: "translate(-0.001 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_80038",
    "data-name": "Path 80038",
    d: "M115-9.6h23.808c4.535,0,7.936,1.134,10.456,3.023A11.88,11.88,0,0,1,153.547,3c0,4.661-1.89,7.558-5.669,9.322v.252c5.039,1.638,7.936,6.173,7.936,11.589,0,5.165-2.016,9.2-5.291,11.715-2.771,2.016-6.3,2.9-11.085,2.9H115ZM136.415,9.3c2.519,0,4.409-1.386,4.409-4.283,0-2.771-1.89-4.157-4.535-4.157H128.1V9.17h8.314Zm1.134,18.77c2.9,0,5.039-1.764,5.039-4.913,0-3.4-2.267-4.913-5.039-4.913h-9.322v9.952h9.322Z",
    transform: "translate(-114.999 9.6)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_80039",
    "data-name": "Path 80039",
    d: "M149.1-9.6h12.471V38.9H149.1Z",
    transform: "translate(-106.143 9.6)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_80040",
    "data-name": "Path 80040",
    d: "M161,18.966C161,8.006,168.054.7,179.014.7S196.9,8.132,196.9,18.966c0,10.959-6.928,18.266-17.888,18.266S161,29.925,161,18.966Zm23.431,0c0-6.047-1.89-9.826-5.669-9.826s-5.543,3.779-5.543,9.826,1.764,9.952,5.543,9.952C182.541,28.791,184.431,25.012,184.431,18.966Z",
    transform: "translate(-103.053 12.275)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_80041",
    "data-name": "Path 80041",
    d: "M190.6,18.966C190.6,8.006,197.654.7,208.614.7s17.762,7.306,17.762,18.266-6.928,18.266-17.888,18.266C197.654,37.231,190.6,29.925,190.6,18.966Zm23.431,0c0-6.047-1.89-9.826-5.669-9.826s-5.543,3.779-5.543,9.826,1.764,9.952,5.543,9.952C212.141,28.791,214.031,25.012,214.031,18.966Z",
    transform: "translate(-95.365 12.275)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_80042",
    "data-name": "Path 80042",
    d: "M221,1.608h11.589V6.773h.252C235.109,2.741,238.258.6,243.3.6a9.567,9.567,0,0,1,9.322,5.921h.252C255.642,1.986,259.3.6,263.578.6c8.062,0,11.463,5.921,11.463,13.857V36.124H262.948V16.6c0-3.527-1.134-5.795-4.157-5.795s-4.535,2.771-4.535,6.55v18.77H242.163V16.6c0-3.527-1.134-5.795-4.157-5.795s-4.535,2.771-4.535,6.55v18.77H221Z",
    transform: "translate(-87.47 12.249)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_80043",
    "data-name": "Path 80043",
    d: "M278.415,34.238h-.126v4.535H266.7V-9.6h12.093V7.784h.252a11.468,11.468,0,0,1,9.826-4.661c8.692,0,13.731,7.81,13.731,18.266,0,11.715-5.417,18.518-14.487,18.518A10.665,10.665,0,0,1,278.415,34.238ZM290.13,21.263c0-5.543-2.016-9.2-5.669-9.2-3.779,0-6.047,3.653-6.047,9.2s2.393,9.2,6.047,9.2S290.13,26.931,290.13,21.263Z",
    transform: "translate(-75.602 9.6)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_80044",
    "data-name": "Path 80044",
    d: "M296.3,18.866C296.3,8.032,303.48.6,313.81.6A16.649,16.649,0,0,1,325.9,5.135c4.031,3.905,5.795,9.952,5.669,17.006H308.393c.5,4.283,2.519,6.55,6.173,6.55a4.722,4.722,0,0,0,4.787-3.275h11.715c-2.016,7.936-8.188,11.841-16.88,11.841C303.48,37.131,296.3,29.825,296.3,18.866Zm12.093-3.653h11.085c-.252-4.157-2.519-6.3-5.417-6.3C310.661,8.788,308.771,11.182,308.393,15.213Z",
    transform: "translate(-67.915 12.249)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_80045",
    "data-name": "Path 80045",
    d: "M337.589,7.476h.252C340.361,2.69,343.636.8,347.793.8a3.76,3.76,0,0,1,2.016.378V11.759h-.252c-7.18-1.26-11.337,2.141-11.337,9.952V36.2H326V1.556h11.589Z",
    transform: "translate(-60.201 12.301)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_80046",
    "data-name": "Path 80046",
    d: "M346.03,36.276h11.715c.5,1.512,2.016,2.9,4.913,2.9,3.905,0,5.291-2.393,5.291-6.047V30.607H367.7a10.351,10.351,0,0,1-8.314,3.905c-7.432,0-13.983-5.543-13.983-16.376C345.4,8.184,350.691.5,358.753.5c4.661,0,7.432,1.89,9.322,4.787h.252V1.508h11.589V31.489c0,5.543-1.89,9.826-4.787,12.345-3.023,2.645-7.306,3.779-12.219,3.779C353.588,47.739,347.164,43.96,346.03,36.276Zm22.423-18.644c0-4.283-2.016-7.81-5.543-7.81-3.4,0-5.543,3.023-5.543,7.81,0,4.661,2.142,7.936,5.543,7.936S368.453,22.167,368.453,17.632Z",
    transform: "translate(-55.163 12.223)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewBloombergLogo);
export default __webpack_public_path__ + "static/media/New_Bloomberg_Logo.f6d60aad7a337c2ef9c22a7f97fe5a01.svg";
export { ForwardRef as ReactComponent };